module.exports = __webpack_public_path__ + "static/media/back.f7bd6405.svg";